import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Text, Margin, Panel, Link } from 'shared/components'
import { InWinImage } from 'routes/shared/components'
import { team } from 'routes/route.map'

import * as styles from './styles'
import { getFormattedDate, getStatus, getLocation } from './helpers'

const EventDetailsPanelComponent = ({ event }) => (
  <Panel>
    <main>
      <Grid>
        <Row css={styles.row}>
          <Col xs={12} sm={8}>
            <Margin bottom={2} css={styles.header}>
              {event?.jurisdiction?.logo && (
                <Margin right={2}>
                  <InWinImage
                    source={event?.jurisdiction?.logo}
                    alt={event?.jurisdiction?.logo}
                    css={styles.flag}
                  />
                </Margin>
              )}
              <Text as="h1" size={20} bold>
                {event?.tournament?.tournamentName}
              </Text>
            </Margin>
            <Margin tb={1}>
              <Text>Started: </Text>
              <Text bold>{getFormattedDate(event, 'startTime')}</Text>
            </Margin>
            <Margin tb={1}>
              <Text>Location: </Text>
              <Text bold>{getLocation(event)}</Text>
            </Margin>
            <Margin tb={1}>
              <Link as="a" href={event?.website}>
                {event?.website}
              </Link>
            </Margin>
          </Col>
          <Col xs={12} sm={4}>
            <div css={styles.resultsWrapper}>
              <div css={styles.results}>
                <Text as="header">{getStatus(event)}</Text>
                <main>
                  <div>
                    <Link theme="black" to={team.view(event?.teamOne?.id)}>
                      {event?.teamOne?.logo && (
                        <InWinImage
                          source={event?.teamOne?.logo}
                          alt={event?.teamA}
                          css={styles.logo}
                        />
                      )}
                      <Text block>{event?.teamA}</Text>
                    </Link>
                  </div>
                  <div>
                    <Link theme="black" to={team.view(event?.teamTwo?.id)}>
                      {event?.teamTwo?.logo && (
                        <InWinImage
                          source={event?.teamTwo?.logo}
                          alt={event?.teamB}
                          css={styles.logo}
                        />
                      )}
                      <Text block>{event?.teamB}</Text>
                    </Link>
                  </div>
                </main>
                {event?.winner && (
                  <footer>
                    <Text>Winner: {event?.winner}</Text>
                  </footer>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
    </main>
  </Panel>
)

EventDetailsPanelComponent.propTypes = {
  event: PropTypes.shape(),
}

export default EventDetailsPanelComponent
